export default [{
  "productId": '1',
  "servCode": '1010120',
  "servLevel": '01',
  "salePrice": 1499.00,
  "productNum": 2,
  "limitNum": 100,
  "checked": "0",
  "productName": "FIIL Diva Pro 全场景无线降噪耳机",
  "productImg": "http://image.smartisanos.cn/resource/804b82e4c05516e822667a23ee311f7c.jpg"
}, {
  "productId": '2',
  "servCode": '1010120',
  "servLevel": '01',
  "salePrice": 1499.00,
  "productNum": 2,
  "limitNum": 100,
  "checked": "0",
  "productName": "FIIL Diva Pro 全场景无线降噪耳机",
  "productImg": "http://image.smartisanos.cn/resource/804b82e4c05516e822667a23ee311f7c.jpg"
}, {
  "productId": '3',
  "servCode": '1010120',
  "servLevel": '02',
  "salePrice": 2999.00,
  "productNum": 1,
  "limitNum": 100,
  "checked": "0",
  "productName": "畅呼吸智能空气净化器超级除甲醛版",
  "productImg": "https://resource.smartisan.com/resource/71432ad30288fb860a4389881069b874.png"
}, {
  "productId": 4,
  "servCode": '1010120',
  "servLevel": '03',
  "salePrice": 199.00,
  "productNum": 1,
  "limitNum": 100,
  "checked": "0",
  "productName": "Smartisan 牛津纺衬衫",
  "productImg": "https://resource.smartisan.com/resource/a1c53b5f12dd7ef790cadec0eaeaf466.jpg"
}, {
  "productId": 5,
  "servCode": '1010120',
  "servLevel": '03',
  "salePrice": 199.00,
  "productNum": 1,
  "limitNum": 100,
  "checked": "0",
  "productName": "Smartisan 牛津纺衬衫",
  "productImg": "https://resource.smartisan.com/resource/a1c53b5f12dd7ef790cadec0eaeaf466.jpg"
},
{
  "productId": '6',
  "servCode": '1010120',
  "servLevel": '01',
  "salePrice": 1499.00,
  "productNum": 2,
  "limitNum": 100,
  "checked": "0",
  "productName": "FIIL Diva Pro 全场景无线降噪耳机",
  "productImg": "http://image.smartisanos.cn/resource/804b82e4c05516e822667a23ee311f7c.jpg"
}, {
  "productId": '7',
  "servCode": '1010120',
  "servLevel": '01',
  "salePrice": 1499.00,
  "productNum": 2,
  "limitNum": 100,
  "checked": "0",
  "productName": "FIIL Diva Pro 全场景无线降噪耳机",
  "productImg": "http://image.smartisanos.cn/resource/804b82e4c05516e822667a23ee311f7c.jpg"
}, {
  "productId": '8',
  "servCode": '1010120',
  "servLevel": '02',
  "salePrice": 2999.00,
  "productNum": 1,
  "limitNum": 100,
  "checked": "0",
  "productName": "畅呼吸智能空气净化器超级除甲醛版",
  "productImg": "https://resource.smartisan.com/resource/71432ad30288fb860a4389881069b874.png"
}, {
  "productId": 9,
  "servCode": '1010120',
  "servLevel": '03',
  "salePrice": 199.00,
  "productNum": 1,
  "limitNum": 100,
  "checked": "0",
  "productName": "Smartisan 牛津纺衬衫",
  "productImg": "https://resource.smartisan.com/resource/a1c53b5f12dd7ef790cadec0eaeaf466.jpg"
}, {
  "productId": 10,
  "servCode": '1010120',
  "servLevel": '03',
  "salePrice": 199.00,
  "productNum": 1,
  "limitNum": 100,
  "checked": "0",
  "productName": "Smartisan 牛津纺衬衫",
  "productImg": "https://resource.smartisan.com/resource/a1c53b5f12dd7ef790cadec0eaeaf466.jpg"
},
{
  "productId": '11',
  "servCode": '1010120',
  "servLevel": '01',
  "salePrice": 1499.00,
  "productNum": 2,
  "limitNum": 100,
  "checked": "0",
  "productName": "FIIL Diva Pro 全场景无线降噪耳机",
  "productImg": "http://image.smartisanos.cn/resource/804b82e4c05516e822667a23ee311f7c.jpg"
}, {
  "productId": '12',
  "servCode": '1010120',
  "servLevel": '01',
  "salePrice": 1499.00,
  "productNum": 2,
  "limitNum": 100,
  "checked": "0",
  "productName": "FIIL Diva Pro 全场景无线降噪耳机",
  "productImg": "http://image.smartisanos.cn/resource/804b82e4c05516e822667a23ee311f7c.jpg"
}, {
  "productId": '13',
  "servCode": '1010120',
  "servLevel": '02',
  "salePrice": 2999.00,
  "productNum": 1,
  "limitNum": 100,
  "checked": "0",
  "productName": "畅呼吸智能空气净化器超级除甲醛版",
  "productImg": "https://resource.smartisan.com/resource/71432ad30288fb860a4389881069b874.png"
}, {
  "productId": 14,
  "servCode": '1010120',
  "servLevel": '03',
  "salePrice": 199.00,
  "productNum": 1,
  "limitNum": 100,
  "checked": "0",
  "productName": "Smartisan 牛津纺衬衫",
  "productImg": "https://resource.smartisan.com/resource/a1c53b5f12dd7ef790cadec0eaeaf466.jpg"
}, {
  "productId": 15,
  "servCode": '1010120',
  "servLevel": '03',
  "salePrice": 199.00,
  "productNum": 1,
  "limitNum": 100,
  "checked": "0",
  "productName": "Smartisan 牛津纺衬衫",
  "productImg": "https://resource.smartisan.com/resource/a1c53b5f12dd7ef790cadec0eaeaf466.jpg"
}]



// WEBPACK FOOTER //
// ./src/assets/config/order/orderList.js